import { Skeleton, Typography } from "@mui/material"
import type { FC } from "react"

interface CountBoxProps {
  label: string
  value: string | null
  loading?: boolean
  "data-testid": string
}

export const CountBox: FC<CountBoxProps> = ({ label, value, loading = false, "data-testid": testId }) => (
  <div className='flex h-16 min-w-28 flex-col justify-center rounded-md bg-gray-200 px-4' data-testid={testId}>
    <Typography variant='caption' component='span' className='text-primary'>
      {label}
    </Typography>
    {loading ? (
      <Typography variant='h6' component='span' className='flex w-full'>
        <Skeleton variant='rectangular' width='66%' />
      </Typography>
    ) : (
      <Typography variant='h6' component='span' className='font-bold text-gray-700'>
        {value ?? "—"}
      </Typography>
    )}
  </div>
)
